import { Boundaries } from "@planzone/core";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { State } from "./types";

function handleFailure(
  state: State,
  data: Boundaries["retrieveZonesProjects"]["failure"],
): State {
  return { ...state, request: setRequestStateToFailure() };
}

export { handleFailure };
